<template>
  <div>
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
 <div style="text-align:center;"> 
   <h4 class="title">Document Signing</h4>
 </div>
 


<div style="margin-top:80px;"> 
   <h4 class="title">Who Should Sign</h4>
 </div>
 <!-- start: who should sign -->
 <card>
         
          
           <div style=''> 
          		<span class="title" style="font-size:21px;">Officers </span> 
          		<span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_officers()" v-if="show_all_officers==false">(Show All Officers)</span>
                <span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_officers_false()" v-if="show_all_officers==true">(Hide Inactive Officers)</span>

          </div>
          <div v-for="officer in coy.officers" >
          	
          	<p-checkbox style="margin-bottom:15px;margin-top:15px;" :id="officer.id" :value="officer.id"  v-if="officer.pivot.status!=2 || show_all_officers == true" 
          	:disabled="readyToSend==true"
          	 v-model="selectedOfficers['o'+officer.id]">
          		<span style="color:#000">{{officer.person.first_name}} {{officer.person.last_name}} 
          		
          		<span v-if="officer.pivot.status==2 || officer.pivot.status==3" style="color:red;">(Inactive) </span>
          		
          		
          			(
          			<span v-if="officer.pivot.position==1" >Director</span>
  	 		 		<span v-if="officer.pivot.position==2" >Nominee Director</span>
			 		<span v-if="officer.pivot.position==3" >Corp Sec</span>
          		
          			)
          			
          		</span>
          		<span v-if="officer.person.email" style="color:#000">- {{officer.person.email}}</span>
          		</p-checkbox>
          </div>
          
        
          
      <div v-if="coy.company_type!=7">
            <div style='margin-top:50px;'> 
          		<span class="title" style="font-size:21px;">Shareholders </span> 
          		<span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_shareholders()" v-if="show_all_shareholders==false">(Show All Shareholders)</span>
                <span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_shareholders_false()" v-if="show_all_shareholders==true">(Hide Inactive Shareholders)</span>

          </div>
           
           
           
           
           <div v-for="shareholder in coy.shareholders" >
          	
          	<div v-if="shareholder.person && (shareholder.num_shares>0 || show_all_shareholders == true)">
          	<p-checkbox v-if="shareholder" style="margin-bottom:15px;margin-top:15px;" :id="shareholder.id" :value="shareholder.id" 
          	:disabled="readyToSend==true"
          	 v-model="selectedShareholders['s'+shareholder.id]">
          			<span style="color:#000">{{shareholder.person.first_name}} {{shareholder.person.last_name}} </span>
          			
          			- ({{shareholder.num_shares}} 
						 <span v-if="shareholder.pivot.share_type==1">Ordinary</span>
						 <span v-if="shareholder.pivot.share_type==2">Preference</span>
						<span v-for="st in coy.share_types">
						  <span v-if="shareholder.pivot.share_type==st.id">{{st.name}}</span>
					  </span>
					   Shares) -  
          			
          			<span v-if="shareholder.person.email" style="color:#000"> {{shareholder.person.email}}</span>
          		
          	</p-checkbox>
          	</div>	
          	
          <div  v-if="shareholder.shareholder_company && (shareholder.num_shares>0 || show_all_shareholders == true)">
          	<p-checkbox v-if="shareholder" style="margin-bottom:15px;margin-top:15px;" :id="shareholder.id" :value="shareholder.id" 
          	:disabled="readyToSend==true"
          	 v-model="selectedShareholders['s'+shareholder.id]">
          	  		<span v-if="shareholder.is_company==1">{{shareholder.shareholder_company.company_name}} - </span>
          	  		
          	  		({{shareholder.num_shares}}
          			 <span v-if="shareholder.pivot.share_type==1">Ordinary</span>
  	 				 <span v-if="shareholder.pivot.share_type==2">Preference</span>
          			<span v-for="st in coy.share_types">
				  	  <span v-if="shareholder.pivot.share_type==st.id">{{st.name}}</span>
				  </span>
				   Shares)
				   
				   
					 (Representative: 
          			<span style="color:#000">{{shareholder.shareholder_company.person.first_name}} {{shareholder.shareholder_company.person.last_name}}  </span>
          			<span v-if="shareholder.shareholder_company.person.email" style="color:#000">- {{shareholder.shareholder_company.person.email}}</span>
          			)
          	</p-checkbox>
          	</div>	
          </div>
     </div> <!-- end shareholder signers -->
          
      <div v-if="coy.company_type==7">
           <div style='margin-top:50px;'> <h5>Members</h5></div>
           <div v-for="member in coy.members" >
          	
          	<div v-if="member.person">
          	<p-checkbox v-if="member" style="margin-bottom:15px;margin-top:15px;" :id="member.id" :value="member.id" 
          	:disabled="readyToSend==true"
          	 v-model="selectedMembers['m'+member.id]">
          			<span style="color:#000">{{member.person.first_name}} {{member.person.last_name}} </span>
          			<span v-if="member.person.email" style="color:#000">- {{member.person.email}}</span>
          		
          	</p-checkbox>
          	</div>	
          	
          	<div v-else>
          	<p-checkbox v-if="member" style="margin-bottom:15px;margin-top:15px;" :id="member.id" :value="member.id" 
          	:disabled="readyToSend==true"
          	 v-model="selectedMembers['m'+member.id]">
          	  		<span v-if="member.is_company==1">{{member.shareholder_company.company_name}} - </span>
					 (Representative: 
          			<span style="color:#000">{{member.shareholder_company.person.first_name}} {{member.shareholder_company.person.last_name}}  </span>
          			<span v-if="member.shareholder_company.person.email" style="color:#000">- {{member.shareholder_company.person.email}}</span>
          			)
          	</p-checkbox>
          	</div>	
          </div>
     </div> <!-- end members signers -->         
          
          
       
       
      
       
       </card>
       
       
       <card>
       	 <!-- start: add additional signers -->
       <div v-if="!readyToSend" style="padding-bottom:30px;">
       		<h5 class="title">Add Additional Signer(s)</h5>
       
      	 	<div>
       		</div>
       
       
       		 <div  style="text-align:left; margin-top:50px;" v-if="readyToSend==false">
			
			  <div>Add New Signer Using Govt ID Number</div>
				   <fg-input type="text"
                  		name="search_signer_id_num"
                 	    v-model="search_signer_id_num"
                 	    style="max-width:500px"
                 	    >
        			</fg-input>
        	
			  
			   <p-button  type="info" @click.prevent="searchPerson('signer')">Search People</p-button>
			   </div>
       </div>
       
       <!-- end: add additional signers-->
       
       
       </card>
       
       <div v-if="!noAdditionalSigners">
       <h4 class="title">Additional Signers</h4>
       <card>
        <div>
       			  <div v-for="(as, index) in additionalSigners" style="font-weight:bold;">
       			  {{index+1}})	{{as.first_name}} {{as.last_name}} ({{as.gov_id}}) - {{as.email}}
       			   <span v-if="readyToSend==false" style="color:red;cursor:pointer;" @click="removeAdditionalSigner(as.id, as.task_id, index)" > [Delete]</span>
       			  </div>
       		</div>
       </card>
       </div>
 <!-- end: who should sign -->


<div style="margin-top:80px;"> 
   <h4 class="title">Document PDF</h4>
 </div>
 
 
<card>
<div style="">
  			
          <p-button  v-if="main_document.id"  @click="viewDocumentPdf(0)" type="warning">View Original Document</p-button>          
	
</div>




</card>   
    

<div style="margin-top:80px;"> 
   <h4 class="title">Send For Signing</h4>
 </div>
 
 <card v-if="displaySigning">

     <p-button v-if="readyToSend==false && sentForSigning==false"  @click="saveSigners" type="info">Save Signers</p-button>       
     
	 <p-button v-if="readyToSend==true && signing_status=='Not Sent'" @click="sendForSigning()" type="info">Send For Signing</p-button>

 
	 <br/>
	 <p-button v-if="main_document.signed_document_file_name" @click="viewDocumentPdf(1)" type="default">View Signed Document</p-button>
	 <p-button  v-if="main_document.signing_log_file_name"  @click="viewDocumentPdf(2)" type="default">View Signing Log</p-button>
		
		
			<div style="margin-top:50px 0px;">
				<div style="font-weight:bold;font-size:20px"> Signing Status:<span> {{signing_status}}</span></div>
				
				 <p-button v-if="signing_status!='Not Sent'"  @click="refreshStatus()" type="warning">Refresh</p-button>
				 <div v-if="signing_status !='Signing Complete'">
				 	<p-button v-if="signing_status!='Not Sent'"  @click="resendRequest()" type="info">Send Reminders</p-button>
					 <br/><br/>
					  <p-button v-if="signing_status!='Not Sent'"  @click="cancelRequest()" type="danger">Cancel Signing Request</p-button>
				  </div>
			 </div>
        	            
    
 </card>       	 


<!-- footer spacing -->  	 
<div style="width:100%;height:350px;"></div>

<div v-if="placeholder"></div>

  </div>
</template>
<script>
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
     mounted() {
     	 this.docuType = this.$route.params.type;
     	 this.taskid = this.$route.params.tid;
      	 this.loadResolutionBuilder();
      	 
      	 if(this.$route.params.type=="task" && this.$route.params.did != 0){
      	 	this.main_document.id = this.$route.params.did;
      	 }
    },
    data () {
      return {
       main_document: {
        	signing_log_file_name: "",
        	signed_document_file_name:""
        
        },
        signing_status:'Not Sent',
        sentForSigning: false,
        readyToSend: false,
        search_signer_id_num:'',
        show_all_shareholders: true,
        show_all_officers: true,
        selectedOfficersArr:[],
        selectedOfficers: [],
        noAdditionalSigners: false,
        placeholder: "",
        docuType: '',
        selectedShareholdersArr:[],
        selectedShareholders: [],
        selectedMembersArr:[],
        selectedMembers: [],
		additionalSigners: [],
      	displaySigning: false,
        coy:{
        	address: '',
        	name:'',
        	fye:'',
        	activity1:'',
        	activity2:'',
        },
       
      }
    },
    methods:{
    	 click_show_all_shareholders(){
        	this.show_all_shareholders = true;
        },
        click_show_all_shareholders_false(){
        	this.show_all_shareholders = false;
        },
        click_show_all_officers(){
        	this.show_all_officers = true;
        },
        click_show_all_officers_false(){
        	this.show_all_officers = false;
        },
        
        
    	saveSigners(){
    		swal.showLoading();
    		
    		//get signers:
       		const vm = this;
       		vm.selectedOfficersArr = [];
			vm.selectedShareholdersArr = [];
			vm.selectedMembersArr = [];
			
			var off = this.coy.officers;
			off.forEach(function(t){
				if(vm.selectedOfficers["o"+t.id]==true){
					vm.selectedOfficersArr.push(t.id);
				}
			});
			
			
			var shs = this.coy.shareholders;
			shs.forEach(function(s){
				if(s && vm.selectedShareholders["s"+s.id]==true){
					vm.selectedShareholdersArr.push(s.id);
				}
			});
			
			
			var ms = this.coy.members;
			ms.forEach(function(m){
				if(m && vm.selectedMembers["m"+m.id]==true){
					vm.selectedMembersArr.push(m.id);
				}
			});
			
			
    		let uri = this.$base_url+'/api/v1/documents/save_signers';
      		ApiService.post(uri, {
    			 "officers_signer":this.selectedOfficersArr,
    			 "shareholders_signer":this.selectedShareholdersArr,
    			 "members_signer":this.selectedMembersArr,
    			 "additional_signers": this.additionalSigners,
    			 "tid": this.taskid,
    			 "did": this.$route.params.did,
    		}).then(response => {
      	
         			swal({
						  title: 'Saved',
						  text: 'The signers have been saved. You may send the document for signing.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
					})
         			this.readyToSend = true;
         		
         			
         			
         			
     		})//end response
    	
    	
    	},
    	removeAdditionalSigner(pid, tid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/tasks/delete_as/'+pid+"/"+tid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted',
					  text: 'The additional signer has been removed.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.additionalSigners.splice(index, 1);
					})
					//end swal
				})


			  })//end swal

    	},
    	loadTaskInfo(){
    		if(this.taskid != 0){
				 this.displaySigning = true;
				 
      			 if(this.$route.params.type == "reso"){
					 let uri = this.$base_url+'/api/v1/tasks/get_custom_reso/'+ this.taskid;
					 ApiService.get(uri).then(response => {
			 
							const vm = this;
							if(response.data.main_document){
								this.main_document =  response.data.main_document;
								//this.main_document.id =  response.data.task.main_document;
							
								if(this.main_document.signing_status != null){
									this.main_document = response.data.main_document;
							
									this.updateSigningStatus(this.main_document.signing_status);			
									this.sentForSigning =  true; //no edits allowed after sent for signing
								}
							}


						
							if(response.data.additional_signers){
								this.additionalSigners = response.data.additional_signers;
								
								if(this.additionalSigners.length == 0){
									this.noAdditionalSigners = true;
								}
							}

					
							//process signers					
							response.data.saved_signers.forEach(function(signer){
								if(signer.type==1){
									vm.selectedOfficers["o"+signer.officer_id] = true;
								
								}
								else if(signer.type==2){
							
									vm.selectedShareholders["s"+signer.shareholder_id] = true;
								}
								else if(signer.type==4){
							
									vm.selectedMembers["m"+signer.member_id] = true;
								}
								
							});
							
						
							this.readyToSend = true;
							swal.close();
					})//end response
				
				}//end if reso
				else if(this.$route.params.type == "task"){
					 let uri = this.$base_url+'/api/v1/documents/get_docu_signing_info/did/'+ this.$route.params.did;
					 ApiService.get(uri).then(response => {
						//process signers					
						const vm = this;
						
						if(response.data.document){
								this.main_document =  response.data.document;
								//this.main_document.id =  response.data.task.main_document;
							
								if(this.main_document.signing_status != null){
									this.main_document = response.data.document;
							
									this.updateSigningStatus(this.main_document.signing_status);			
									this.sentForSigning =  true; //no edits allowed after sent for signing
									this.readyToSend = true;
								}
						}
							
							
							
						//process signers					
						response.data.signers.forEach(function(signer){
								if(signer.type==1){
									vm.selectedOfficers["o"+signer.officer_id] = true;
								
								}
								else if(signer.type==2){
							
									vm.selectedShareholders["s"+signer.shareholder_id] = true;
								}
								else if(signer.type==3){
									vm.additionalSigners.push(signer.person);
								}
								else if(signer.type==4){
							
									vm.selectedMembers["m"+signer.member_id] = true;
								}
							});
						
						if(this.additionalSigners.length == 0){
							this.noAdditionalSigners = true;
						 }
								
						this.placeholder = false;
						swal.close();
					 });
				}
				
			}//end if task exists
			else{
				swal.close();
			}
    	
    	
    	},
    	
		loadResolutionBuilder(){
			swal.showLoading();
			let uri = this.$base_url+'/api/v1/entities/simple_details/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
						this.coy = response.data.entity;
						let vm = this;
					
						
						//for signing
						response.data.entity.officers.forEach(function(officer){
							
							vm.selectedOfficers["o"+officer.id] = false;
						});
					
						//for signing
						response.data.entity.shareholders.forEach(function(shareholder){
							if(shareholder){
								vm.selectedShareholders["s"+shareholder.id] = false;
							}
						});
						
						
						
					
						this.loadTaskInfo();
			})
		
		
			

		},//end resolutionBuilder
		searchPerson(type){
       		let search_term = "NONE";
       		 if(type == "signer"){
       			if(this.search_signer_id_num){
       				search_term = this.search_signer_id_num
       			}
       		}
       		
       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;
       		
       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){
      				
      					 if(type == "signer"){
      						
      						this.additionalSigners.push(response.data.person); 
      						this.noAdditionalSigners = false;
      					}//end if-else 
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Person not found. Please add this person to the database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
				
						})
      				
      					
      				}
         		
     		 })
    	
    	},//end search person
        viewDocumentPdf(type){
    		this.$router.push( '/view-document/'+this.main_document.id+"/"+type);
    	},
        sendForSigning(){
        	swal.showLoading();
    		let uri = this.$base_url+'/api/v1/documents/send_signing';
      		ApiService.post(uri, {
    			"pdf_path":this.pdf_path,
    			"tid": this.taskid,
    			"did": this.$route.params.did,
    			"type": this.$route.params.type,
    		}).then(response => {
    		
    				if(response.data.success == 0){
						swal({
							  title: 'Oops!',
							  text: response.data.error,
							  type: 'error',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
						})
							
					}
					else{
      	
						//alert("document generated at: "+response)
						this.sentStatus = 1;
						this.signing_status = "Document sent to signee for signing";
					
						swal.close();
         			}
         			
         			
     		 })

    	},
    	cancelRequest(){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, cancel it.',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/documents/cancel_sr';

				 ApiService.post(uri, {
				 	"tid":vm_.taskid,
					"did": vm_.$route.params.did,
    				"type": vm_.$route.params.type,

				 }).then(response => {
					swal({
					  title: 'Done',
					  text: 'The signing request has been cancelled.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
						vm_.$router.push( '/edit-task/'+vm_.taskid+'/entity/'+vm_.$route.params.eid)
						
					})
					//end swal
				})


			  })//end swal
    	
    	
    	
    	
    	},
    	refreshStatus(){
    		
    		
    		
    		swal.showLoading();
    	    const vm = this;
			let uri2 = this.$base_url+'/api/v1/documents/refresh';
				ApiService.post(uri2, {
					"tid":this.taskid,
					"did": this.$route.params.did,
    				"type": this.$route.params.type,
				}).then(response => {
							vm.main_document = response.data.document;
							this.updateSigningStatus(vm.main_document.signing_status);
							swal.close();
					
			})
			
			//end testing	 
    	
    	},
    	resendRequest(){
    		swal.showLoading();
    	    const vm = this;
			let uri2 = this.$base_url+'/api/v1/documents/resend_sr';
				ApiService.post(uri2, {
					"tid":this.taskid,
					"did": this.$route.params.did,
    				"type": this.$route.params.type,
				}).then(response => {
							swal({
							  title: 'Reminders sent out successfully',
							  text: 'Email reminders have been sent out to signers who have not signed the document.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
						})
							
					
			})
    	
    	
    	
    	
    	},
      
       updateSigningStatus(status){
       		this.signing_status = "Not Sent";
       		if(status == "vi"){
				this.signing_status = "Viewed By Signers";
			}
			else if(status == "se"){
				this.signing_status = "Sent For Signing";
			}
			else if(status == "si"){
				this.signing_status = "Signing Complete";
			}
			else if(status == "co"){
				this.signing_status = "Processing Document For Signing";
			}
       },
       
       goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	    },
    },
   
    
  }
</script>
<style>
</style>
